import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx } from "vue"

import { computed, inject, ref, watch } from "vue";
import ModalBase from "../ui/modals/modal-base.vue";
import { ModalWidth } from "@/types/ui/modals/ModalWidth";
import { NameValuePair } from "@/types/generic/NameValuePair";
import displayErrorMessage from "@/utils/ErrorHandling";
import { getErrorMessage } from "bright-logic-core/src/errors";
import { AcquaintApiClient } from "@/services/AcquaintApiClient";
import AcquaintInfoBox from "../ui/inputs/acquaint-info-box.vue";
import { DxToolbarItem } from "devextreme-vue/popup";
import { version } from "../../../package.json";


export default /*#__PURE__*/_defineComponent({
  __name: 'system-info-modal',
  props: {
  /**
   * The boolean value used with `v-model` to control the visibility or state of a modal or component.
   * @type {boolean}
   * @required
   */
  modelValue: {
    type: Boolean,
    required: true,
  },
},
  emits: [
  /**
   * Triggered when the `modelValue` changes.
   * This is used to update the v-model variable in the parent component and control the visibility of the modal.
   * @event update:modelValue
   * @property {boolean} value - The updated state to reflect whether the modal should be shown or hidden.
   */
  "update:modelValue",
],
  setup(__props, { emit }) {

const props = __props;





const showModal = computed({
  get: () => props.modelValue,
  set: (value: boolean) => emit("update:modelValue", value),
});

const apiClient = inject("AcquaintApiClient") as AcquaintApiClient;
const systemInfo = ref<NameValuePair[]>([]);

/** Calls api to retrieve system info */
const getSystemInfo = async () => {
  try {
    return await apiClient.httpGet<NameValuePair[]>("app/system/info");
  } catch (err) {
    await displayErrorMessage(getErrorMessage(err));
    return [];
  }
};

/* When modal is shown, call api to get current system info.
 * This is deliberately not cached, so we can troubleshoot issues */
watch(
  () => props.modelValue,
  async () => {
    if (!props.modelValue) {
      return;
    }

    systemInfo.value = await getSystemInfo();
  },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalBase, {
    modelValue: showModal.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showModal).value = $event)),
    title: "System Information",
    width: _unref(ModalWidth).XSmall
  }, {
    content: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(systemInfo.value, (item, index) => {
        return (_openBlock(), _createBlock(AcquaintInfoBox, {
          key: index,
          label: item.name,
          text: item.value
        }, null, 8, ["label", "text"]))
      }), 128)),
      _createVNode(AcquaintInfoBox, {
        label: "Version",
        text: _unref(version)
      }, null, 8, ["text"])
    ]),
    footer: _withCtx(() => [
      _createVNode(_unref(DxToolbarItem), {
        widget: "dxButton",
        toolbar: "bottom",
        location: "after",
        options: { text: 'Close', onClick: () => (showModal.value = false) },
        shortcut: "cancel"
      }, null, 8, ["options"])
    ]),
    _: 1
  }, 8, ["modelValue", "width"]))
}
}

})